/** Categorisation of a status-log note (maps to master auth status or a generic "other"). */
export enum StatusNoteType {
  PENDING = "pending",
  QUERY = "query",
  NOTES = "notes",
  OTHER = "other",
}
